import { StickableTanstackTable } from 'components/common/Table/StickableTanstackTable';
import {
  StreamingStatusListColumns,
  useStreamingStatusListModel
} from './StreamingStatusListModel';
import { StreamingStatusDTO } from 'core/streamingStatus/StreamingStatus';
import i18n from 'i18n';
import { useCallback } from 'react';
import IconWithTooltip from 'components/IconWithTooltip/IconWithTooltip';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { Page } from 'components/Page/Page';
import { Link } from 'react-router-dom';

export type StreamingStatusListProps = {
  streamingStatusList: StreamingStatusDTO[];
};

export const StreamingStatusList: React.FC<StreamingStatusListProps> = ({
  streamingStatusList
}) => {
  const { searchString, filteredList, columns, onSearch } =
    useStreamingStatusListModel(streamingStatusList);

  const renderRowBtns = useCallback((item: StreamingStatusDTO) => {
    return [
      <IconWithTooltip
        key={item.crid}
        icon={faPencilAlt}
        tooltipProps={{
          id: `streaming-status-edit-tip-${item.crid}`,
          tooltip: i18n.t('streamingStatusList.hints.edit'),
          link: `/system/streaming-status/${item.crid}/edit`
        }}
      />
    ];
  }, []);

  const renderListOperations = useCallback(
    () => [
      <Link
        key='new-btn'
        to={'/system/streaming-status/new'}
        className={'btn btn-tertiary btn-sm'}
      >
        {i18n.t('streamingStatus.labels.create')}
      </Link>
    ],
    []
  );

  return (
    <div style={{ height: '100%' }}>
      <Page title={i18n.t('streamingStatus.title')}>
        <StickableTanstackTable
          keyField={StreamingStatusListColumns.CRID}
          customPadding={false}
          data={filteredList}
          columns={columns}
          noDataIndication={i18n.t('streamingStatus.labels.noData')}
          defaultSearchString={searchString}
          onHandleSearch={onSearch}
          renderRowBtns={renderRowBtns}
          renderListOperations={renderListOperations}
        />
      </Page>
    </div>
  );
};
